import React, { ReactElement } from 'react';
import * as webStorage from '@com.rakuten.esd/myr-web-storage';
import { ConfirmationOverlay } from '../app/common/components/ConfirmationOverlay';
import { TranslationHelpers } from '../i18n/translationHelpers';
import ErrorRedirectService from '../routes/error/errorRedirect.service';
import { OtpStatesKey } from '../details/accountSecurity/verifyEmail/verifyEmailUtils';

export interface ISignOutLinkOwnProps {
    children: ReactElement;
    qaId?: string;
}

export interface ISignOutLinkStateProps {
    callbackUrl: string;
    postLogoutUrl?: string;
}

export type SignOutLinkProps = ISignOutLinkOwnProps & ISignOutLinkStateProps;

export interface ISignOutLinkState {
    confirmationOpen: boolean;
}

class SignOutLink extends React.Component<SignOutLinkProps, ISignOutLinkState> {
    constructor(props: SignOutLinkProps) {
        super(props);

        this.state = {
            confirmationOpen: false,
        };

        this.openConfirmation = this.openConfirmation.bind(this);
        this.onAcceptSignOut = this.onAcceptSignOut.bind(this);
        this.onCancelSignOut = this.onCancelSignOut.bind(this);
        this.onConfirmationClose = this.onConfirmationClose.bind(this);
    }

    public render() {
        const { children, qaId } = this.props;
        const { confirmationOpen } = this.state;

        return (
            <React.Fragment>
                {React.cloneElement(children, {
                    'data-qa-id': `${qaId}-sign-out`,
                    onClick: this.openConfirmation,
                })}
                <ConfirmationOverlay
                    title={TranslationHelpers.getMessageDescriptor('app.logout')}
                    isOpen={confirmationOpen}
                    onAccept={this.onAcceptSignOut}
                    onCancel={this.onCancelSignOut}
                    onClose={this.onConfirmationClose}
                    confirmButtonText={TranslationHelpers.getMessageDescriptor('app.logout')}
                >
                    {TranslationHelpers.getFormattedMessage('app.logout.confirm')}
                </ConfirmationOverlay>
            </React.Fragment>
        );
    }

    private openConfirmation() {
        this.setState({ confirmationOpen: true });
    }

    private onAcceptSignOut() {
        const { callbackUrl, postLogoutUrl } = this.props;
        const logoutUrl = postLogoutUrl
            ? `&post_logout_uri=${postLogoutUrl}&do_logout=${true}`
            : '?do_logout=${true}';
        const clientId = webStorage.getActiveClientId();
        localStorage.removeItem(OtpStatesKey);
        if (clientId) {
            window.location.assign(`${callbackUrl}logout?clientId=${clientId}${logoutUrl}`);
            this.setState({ confirmationOpen: false });
        } else {
            // if client id is null, redirect to unexpected error
            ErrorRedirectService.unexpected();
        }
    }

    private onCancelSignOut() {
        this.setState({ confirmationOpen: false });
    }

    private onConfirmationClose() {
        this.setState({ confirmationOpen: false });
    }
}

export default SignOutLink;
